"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _react = require('react');

var _entity = require('shared/services/entity');










const usePinnedOrgPolicy = ({
  recipients,
  senderOrgKey,
  onFilterEntities,
  markNextEmptyAsFilterDriven,
}) => {
  const previousPatientOrgKeyRef = _react.useRef(null)
  const patientOrgKey = _react.useMemo.call(void 0, () => {
    const patient = recipients.find(entity => _entity.isEntityPatient.call(void 0, entity))
    return patient && _entity.isEntityPatient.call(void 0, patient)
      ? patient.wrappedEntity.OrgKey
      : null
  }, [recipients])

  const filterRecipientsForOrg = _react.useCallback.call(void 0, (orgKey) => {
    const isValidForOrg = (entity) =>
      _entity.isEntityPatient.call(void 0, entity) || _entity.isEntityTeam.call(void 0, entity)
        ? entity.wrappedEntity.OrgKey === orgKey
        : true
    if (
      recipients.length > 0
      && !recipients.some(isValidForOrg)
    ) {
      markNextEmptyAsFilterDriven()
    }
    onFilterEntities(isValidForOrg)
  }, [markNextEmptyAsFilterDriven, onFilterEntities, recipients])

  _react.useEffect.call(void 0, () => {
    const previousPatientOrgKey = previousPatientOrgKeyRef.current
    previousPatientOrgKeyRef.current = patientOrgKey
    if (!previousPatientOrgKey && patientOrgKey) {
      filterRecipientsForOrg(patientOrgKey)
    }
  }, [filterRecipientsForOrg, patientOrgKey])

  const hasRecipientOrgConflict = !!patientOrgKey
    && (
      senderOrgKey !== patientOrgKey
      || recipients.some(entity =>
        (_entity.isEntityPatient.call(void 0, entity) || _entity.isEntityTeam.call(void 0, entity))
        && entity.wrappedEntity.OrgKey !== patientOrgKey,
      )
    )

  return {
    filterRecipientsForOrg,
    hasRecipientOrgConflict,
    patientPinnedOrgKey: patientOrgKey,
  }
}

exports. default = usePinnedOrgPolicy
